@if (password) {
  <div class="password-strength-meter">
    <div class="password-strength-meter__bar">
      <div
        class="password-strength-meter__fill"
        [style.width.%]="getStrengthPercentage()"
        [style.background-color]="scoreColor"
      ></div>
    </div>
    <div class="password-strength-meter__info">
      @if (scoreLabel) {
        <span class="password-strength-meter__label" [style.color]="scoreColor">
          {{ scoreLabel }}
        </span>
      }
      @if (enableFeedback && feedback) {
        <span class="password-strength-meter__feedback">{{ feedback }}</span>
      }
    </div>
  </div>
}
